<!--P087-->
<template>
  <div class="div_content">
    <div class="cs_margin_top_sm ui_hierarchy">
      <div class="cs_cursor_pointer ui_txt_hierarchy" @click="$router.push({name:'StaffManage'})">员工管理</div>
      <div class="ui_txt_hierarchy">&nbsp;>&nbsp;</div>
      <div class="cs_font_bold cs_cursor_pointer ui_txt_hierarchy">添加员工</div>
    </div>
    <!--基本信息-->
    <div class="cs_margin_top ui_divider_title">
      <div class="divider_title_info"></div>
      <div class="title_info">基本信息</div>
    </div>
    <div class="cs_margin_top div_search">
      <div class="cs_title_primary cs_text_default type_info_search">工号</div>
      <input v-model="search.num" class="cs_input cs_radius_lg edtxt_info_search ui_margin_left_44" placeholder="请输入">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">姓名</div>
      <input v-model="search.name" class="cs_input cs_radius_lg edtxt_info_search" placeholder="请输入">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">性别</div>
      <web-select :options="SEX"
                  @option-key="updateSex"
                  v-model="search.sexName"
                  class="cs_input cs_radius_lg edtxt_info_search"></web-select>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">年龄</div>
      <input v-model="search.age" class="cs_input cs_radius_lg edtxt_info_search" placeholder="非必填">
      <br>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm">联系方式</div>
      <input v-model="search.mobileNo" class="cs_input cs_radius_lg edtxt_info_search cs_margin_top_sm width_412" placeholder="非必填">
    </div>
    <div class="div_operation_table cs_align_center" style="margin-top:400px;">
      <button @click="btnCancel" class="cs_btn cs_btn_sm ui_btn_ghost_blue"
              type="button">取消
      </button>
      <button @click="btnSave" class="cs_btn cs_btn_sm ui_btn_blue ui_margin_left_88"
              type="button">确认
      </button>
    </div>
    <div class="div_bottom"></div>
  </div>
</template>

<script>
  import WebSelect from "../../components/web-select"
  import {SEX} from "../../assets/utils/constants"
  import WhParameter from "../../assets/csui/parameter/WhParameter"
  export default {
    name: "StaffAdd",
    components: {WebSelect},
    data: function () {
      return {
        search: {
          num: "",
          name: "",
          age: "",
          mobileNo: "",
          sexId: 0,
          sexName: "",
        },
        SEX: SEX,
      }
    },
    created: function () {
    },
    mounted: function() {
    },
    methods: {
      btnSave(){
        try {
          WhParameter.verifyNotEmpty(this.search.num, "工号");
          WhParameter.verifyNotEmpty(this.search.name, "姓名");
        }catch (e) {
          this.$toast(e.message);
          return;
        }
        if(this.isEmptySelect(this.search.sexId)){
          this.$toast("请选择性别");
          return;
        }
        this.$ajax.staff.add.bind(this)(this.search,(data) => {
          this.$toast("添加成功");
          this.$router.push({name:'StaffManage'});
        }, (data) => {
        }, true)
      },
      btnCancel(){
        this.$router.go(-1);
      },
      updateSex(key) {
        this.search.sexId = key;
      },
    },
  }
</script>

<style scoped>
  .width_412{width: 412px;}
</style>



// WEBPACK FOOTER //
// src/page/staff/StaffAdd.vue